        // extend jquery range validator to work for required checkboxes
        var defaultRangeValidator = $.validator.methods.range;
        $.validator.methods.range = function (value, element, param) {
            if (element.type === 'checkbox') {
                // if it's a checkbox return true if it is checked
                return element.checked;
            } else {
                // otherwise run the default validation function
                return defaultRangeValidator.call(this, value, element, param);
            }
        }
        $.validator.methods.number = function (value, element) {
            return this.optional(element) || /-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
        }
    
;
    $(document).ready(function () {
        var IsCE = pzAdCreateMore.v0 + "";
        $(".weight-item").click(function () {
            $(".weight-item").removeClass("active");
            var id = $(this).children().attr("id");
            $(this).addClass("active");
            $('#ChangeAdDescriptionCmd_WeightOptionsID').val(id);
        });
        if (IsCE != "") {
            if (IsCE.toLowerCase() == "true") {
                $('#cargoWeight').show();
            }
            else {
                $('#cargoWeight').hide();
            }
        }
    });

    function fnchangeCategoryLoad(val) {
        if (val != "") {
            sessionStorage.setItem("categoryID", val);
            $.get((pzAdCreateMore.v1 + "/") + val, function (result) {
                if (result.IsCargoEnabled == true) {
                    $('#cargoWeight').show();
                }
                else {
                    $('#cargoWeight').hide();
                }
            });
        }
    }

    function fnchangeCategory(val,event) {
        if (val != "") {
            sessionStorage.setItem("categoryID", val);
            $.get((pzAdCreateMore.v1 + "/") + val, function (result) {
                if (result.IsCargoEnabled == true) {
                    $('#cargoWeight').show();
                    if (result.Weight > 0) {
                            $('#ChangeAdDescriptionCmd_Value').val(result.Weight);
                    }
                    else {
                        $(".weight-item").removeClass("active");
                        $('#ChangeAdDescriptionCmd_WeightOptionsID').val(result.DefaultWeightOptionsId);
                        $(".weight-item").children().each(function (i, data) {
                            if ($(this).attr("id") == result.DefaultWeightOptionsId) {
                                $(this).click();
                                //$(this).parent().addClass("active");
                            }

                        });
                    }
                }
                else {
                    $('#cargoWeight').hide();
                }
            });
        }
    }

    $('#Category').change(function () {
        fnchangeCategory($(this).val());
    });

    $('#SubCategory').change(function () {
        fnchangesubCategory($(this).val());
    });

    function fnchangesubCategory(val, event) {
        if (val != "") {
            val = val.split('-')[0];
            var categoryId = $('#Category').val();
            sessionStorage.setItem("SubcategoryID", val);
            $.get((pzAdCreateMore.v2 + "?Catid=") + categoryId + "&subCatId=" + val, function (result) {
                if (result.IsCargoEnabled == true) {
                    $('#cargoWeight').show();
                    if (result.Weight > 0) {
                        $('#ChangeAdDescriptionCmd_Value').val(result.Weight);
                    }
                    else {
                        $(".weight-item").removeClass("active");
                        $('#ChangeAdDescriptionCmd_WeightOptionsId').val(result.DefaultWeightOptionsId);
                        $(".weight-item").children().each(function (i, data) {
                            if ($(this).attr("id") == result.DefaultWeightOptionsId) {
                                $(this).click();
                            }
                        });
                    }
                }
                else {
                    $('#cargoWeight').hide();
                }
            });
        }
    }
    
